export default "__VITE_ASSET__e0fcd8f1__"